import React from 'react';
import './Preloader.css'


import Logo from '../../Assets/Logos/Logo.svg'

const Preloader = () => {
    return ( 
        <>
            <section className='Preloader'>
                <img className='PreLogo' src={Logo} alt="Logo" />
            </section>
        </>
     );
}
 
export default Preloader;